import { FC } from 'react'

export interface NewlineToBreakProps {
    text: string
    className?: string
}

export const NewlineToBreak: FC<NewlineToBreakProps> = ({ text, className = '' }) => (
    <>
        {text.split('\r\n').map((line, key) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={key} className={className}>
                {line}
                <br />
            </span>
        ))}
    </>
)
